import { render, staticRenderFns } from "./instant-points-modal.vue?vue&type=template&id=09723478&scoped=true&"
import script from "./instant-points-modal.vue?vue&type=script&lang=js&"
export * from "./instant-points-modal.vue?vue&type=script&lang=js&"
import style0 from "./instant-points-modal.vue?vue&type=style&index=0&id=09723478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09723478",
  null
  
)

export default component.exports